//shoes/src/services/adminWholesaleOrders.api.js
import { adminApiRequest } from "./adminApi";

export const getAdminWholesaleOrders = () =>
  adminApiRequest("/admin/wholesale-orders");

export const getAdminWholesaleOrderById = (id) =>
  adminApiRequest(`/admin/wholesale-orders/${id}`);

export const createAdminWholesaleOrder = (data) =>
  adminApiRequest("/admin/wholesale-orders", {
    method: "POST",
    body: JSON.stringify(data),
  });

export const updateAdminWholesaleOrderStatus = (
  id,
  status,
  extraFeeLabel,
  extraFeeAmount,
  adminNote
) =>
  adminApiRequest(`/admin/wholesale-orders/${id}/status`, {
    method: "PUT",
    body: JSON.stringify({
      status,
      extra_fee_label: extraFeeLabel,
      extra_fee_amount: extraFeeAmount,
      admin_note: adminNote,
    }),
  });

export const deleteAdminWholesaleOrder = (id) =>
  adminApiRequest(`/admin/wholesale-orders/${id}`, {
    method: "DELETE",
  });

export const updateAdminWholesaleOrderCustomer = (id, data) =>
  adminApiRequest(`/admin/wholesale-orders/${id}/customer`, {
    method: "PUT",
    body: JSON.stringify(data),
  });
